import React from "react";
import styles from "./ProductDetailsComponent.module.css";
import TextComponent from "../textComponent/TextComponent";

const ProductDetailsComponent = (props) => {
  return (
    <div className={styles.DataContainer}>
      <div className={styles.DataList}>
        {props?.Data?.map((item) => {
          return (
            <div className={styles.DataItem}>
              <TextComponent
                text={item?.label}
                className={styles.label}
                style={{
                  fontSize: item?.label === "Submitted Data" ? " var(--heading2-font-size)" : "var(--smallparagraph-font-size)",
                 }}
              />
              <TextComponent text={item?.description} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductDetailsComponent;
